var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAthmCircleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 39.688 39.688",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1194 0 0 1.1194 -75.457 -118.81)",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.136 141.59a17.727 17.727 0 0 1-17.727-17.727 17.727 17.727 0 1 1 35.454 0 17.727 17.727 0 0 1-17.727 17.727",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.332 116.68-2.1378 3.4555h-5.3102a6.3817 6.3817 0 0 0-6.3817 6.3844v-5.8394a7.4454 7.4454 0 0 1 7.4586-7.4586h4.2333z",
    fill: "#ff6500"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.78 121.21v5.842a7.448 7.448 0 0 1-7.448 7.448h-4.2545l-2.1167-3.4581 2.1167-3.4581h5.3181a6.3844 6.3844 0 0 0 6.3844-6.3738",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m81.961 127.59v6.9162a7.4454 7.4454 0 0 1-7.4586-7.448v-0.52917a6.3817 6.3817 0 0 1 6.3817-6.387h0.52917a1.5875 1.5875 0 0 0-1.5875 1.5875v4.2651a1.5875 1.5875 0 0 0 1.5875 1.5875z",
    fill: "#ffb188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m95.78 120.68v0.52917a6.3844 6.3844 0 0 1-6.3844 6.3738h-0.52917a1.5875 1.5875 0 0 0 1.5875-1.5875v-4.2571a1.5875 1.5875 0 0 0-1.5875-1.5875h-0.52917v-6.9294a7.448 7.448 0 0 1 7.4427 7.4586",
    fill: "#ffd183"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthmCircleLogo);
export default __webpack_public_path__ + "static/media/athm-circle-logo.f7ba5be7db20b18500f1eea8a76b4ccf.svg";
export { ForwardRef as ReactComponent };